import { useNavigate, useParams } from 'react-router-dom';
import { BOOKING_BASE, PROCESS_STEP } from 'routes';

const steps = [
	'',
	PROCESS_STEP.EVENT,
	PROCESS_STEP.PROMOTER,
	PROCESS_STEP.FEE,
	PROCESS_STEP.TECH,
	PROCESS_STEP.TIMES,
	PROCESS_STEP.ACOOMODATION,
	PROCESS_STEP.SUMMARY,
];

export const useStep = () => {
	const navigate = useNavigate();
	const { id, '*': stepId } = useParams();

	const step = stepId;
	const currentStep = steps.indexOf(stepId);

	const prevStepId = currentStep ? currentStep - 1 : 1;
	const nextStepId = currentStep ? currentStep + 1 : 1;

	const redirectNonexistStepToStart = () => {
		if (currentStep < 0) {
			navigate(BOOKING_BASE + id + '/');
		}
	};

	const redirectIfIsStepIsNotDone = (stepsDone: number) => {
		if (currentStep > stepsDone) {
			navigate(BOOKING_BASE + id + '/');
		}
	};

	const goPrevStep = () => {
		const prevStepUrl = BOOKING_BASE + id + '/' + steps[prevStepId < 0 ? 0 : prevStepId];
		navigate(prevStepUrl);
	};

	const goNextStep = () => {
		const nextStepUrl = BOOKING_BASE + id + '/' + steps[nextStepId];
		navigate(nextStepUrl);
	};

	return {
		id,
		step,
		goNextStep,
		goPrevStep,
		redirectNonexistStepToStart,
		redirectIfIsStepIsNotDone,
	};
};
